import React from 'react';
import PropTypes from 'prop-types';
import '../../css/components/bronson/myProfileUser.css';

function ListUiItem({ item, indice }) {
    let nameImage = item.email
        .substring(0, item.email.lastIndexOf('@'))
        .toString();

    const getNameUser = stringName => {
        let arrayTextName = stringName.split(' ');
        let ind = arrayTextName.indexOf('del');
        if (ind > -1) {
            arrayTextName.splice(ind, 1);
        }
        let name = arrayTextName[0];
        let surname = arrayTextName[1];
        let result = '';

        name = name !== undefined ? name.charAt(0) : '';
        surname = surname !== undefined ? surname.charAt(0) : '';

        result = name + surname;
        return result;
    };

    const printUserImage = (strName, strDpto) => {
        let strImage = '';
        if (strDpto === 'Remarketing - Outsourced' || strDpto === '') {
            return (
                <div className="c-my-profile-user c-my-profile-user--contact u-mt u-mb">
                    <div className="c-my-profile-user__initials">
                        <span className="c-page-head-nav__user-text">
                            {getNameUser(strName)}
                        </span>
                    </div>
                </div>
            );
        } else {
            return (
                <img
                    className="o-media__img  u-round"
                    src={
                        process.env.PUBLIC_URL +
                        '/Bronson/img/imgContactsRemarketing/' +
                        nameImage +
                        '.jpg'
                    }
                    alt=""
                />
            );
        }
    };

    return (
        <li className="c-list-ui__item" key={indice}>
            <div className="o-media  o-media--large">
                {printUserImage(item.name, item.dpto)}
                {/* <img className="o-media__img  u-round" src={process.env.PUBLIC_URL + '/Bronson/img/imgContactsRemarketing/' + nameImage + '.jpg'} alt="" /> */}
                <div className="o-media__body">
                    <h4 className="u-mb-none">
                        {item.name != null ? item.name : ''}
                    </h4>
                    <div className="o-layout  u-mb-small">
                        <div className="o-layout__item  u-1/2  u-1/1@s">
                            <p className="u-mb-none">
                                {item.position}
                                <br /> {item.dpto != null ? item.dpto : ''}
                            </p>
                        </div>
                        <div className="o-layout__item  u-1/2  u-1/1@s">
                            <p className="u-mb-none">
                                <a className="u-text-truncate">
                                    {item.phone_1 != null ? item.phone_1 : ''}
                                    <br />
                                    {item.phone_2 != null ? item.phone_2 : ''}
                                </a>
                                <br />
                                <a className="u-text-truncate">
                                    {item.email != null ? item.email : ''}
                                </a>
                            </p>
                        </div>
                    </div>
                    <div className="o-layout u-hide">
                        <div className="o-layout__item  u-1/2  u-1/1@s">
                            <p className="u-mb-none">
                                {/* Agregar texto que se desee presentar */}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
}

export default ListUiItem;
